export interface AssessmentItemTag {
  item: string;
  position: string;
}

export interface AssessmentItemPosition {
  currentItemIndex: number;
  isFirstItem: boolean;
  isLastItem: boolean;
}

export interface ScoreAndTime {
  score: number;
  responseTime: number;
}

export interface AssessmentUserResponseStatus {
  responses: string[];
  attemptedStatus: string;
}

export enum LearnosityItemType {
  Question = 'Question',
  Instruction = 'Instruction',
  Introduction = 'Introduction',
  Stimulus = 'Stimulus',
  Thanks = 'ThanksPage',
}

export enum AssessmentAttemptedStatus {
  FullyAttempted = 'fully_attempted',
  NotAttempted = 'not_attempted',
}

export interface RoutePathParameters {
  orgCode: string;
  campaignCode: string;
  invitationCode: string;
}

export interface PublicRoutePathParameters {
  orgCode: string;
  campaignCode: string;
}
